import { useEffect, useMemo } from 'react';
import { DatePicker, TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { DateButton, TimeButton } from './route-date-time-select.utils';

import 'dayjs/locale/nl-be';

import './route-date-time-select.styl';

dayjs.locale('nl-be');

function RouteDateTimeSelect({ dateTime, setDateTime }) {  
  useEffect(() => {
    if (!dateTime) setDateTime(dayjs().toISOString());
  }, [dateTime, setDateTime]);

  const { minDate, maxDate } = useMemo(() => {
    const today = dayjs().startOf('day');
    const daysSinceSunday = today.day();
    const latestSunday = today.subtract(daysSinceSunday, 'day');
  
    return {
      minDate: latestSunday,
      maxDate: latestSunday.add(30, 'day'),
    };
  }, []);

  const dateTimeObj = useMemo(() => {
    return dateTime ? dayjs(dateTime) : null;
  }, [dateTime]);

  const handleDateChange = (newDate) => {
    if (!dayjs.isDayjs(newDate)) return;

    const updated = dateTimeObj
      .year(newDate.year())
      .month(newDate.month())
      .date(newDate.date());

    setDateTime(updated.toISOString());

    if (updated) {
      window.gtag?.('event', 'home_set_datetime', {
        event_category: 'Home',
        event_label: 'Home set datetime',
        datetime: updated.toISOString(),
      });
    }
  };
  
  const handleTimeChange = (newTime) => {
    if (!dayjs.isDayjs(newTime)) return;

    const updated = dateTimeObj
      .hour(newTime.hour())
      .minute(newTime.minute())
      .second(newTime.second());

    setDateTime(updated.toISOString());
  };

  return (
    <div className="route-date-time-select">
      <LocalizationProvider 
        dateAdapter={AdapterDayjs} 
        adapterLocale="nl-be"
      >
        <DatePicker
          value={dateTimeObj}
          minDate={minDate}
          maxDate={maxDate}
          onChange={handleDateChange}
          className="route-date-time-select__date"
          placeholder="Kies een datum"
          slots={{
            openPickerButton: DateButton,
            openPickerIcon: null,
          }}
          slotProps={{
            textField: {
              variant: 'standard',
              InputProps: { disableUnderline: true, tabIndex: -1 },
            },
          }}
        />
        <TimePicker
          value={dateTimeObj}
          onChange={handleTimeChange}
          className="route-date-time-select__time"
          slots={{
            actionBar: () => null,
            openPickerButton: TimeButton,
          }}
          slotProps={{
            textField: {
              variant: 'standard',
              InputProps: { disableUnderline: true, tabIndex: -1 },
            },
          }}
          ampm={false}
        />
      </LocalizationProvider>
    </div>
  );
}

export default RouteDateTimeSelect;
